module.exports = __webpack_public_path__ + "static/media/16UNODC33.822e99d6.jpg";